// Supplemental routes for export
import Backbone from 'backbone'

import $ from 'jquery'
import KeyCodes from 'scoreboard/components/key-codes'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'
import BaseRouter from 'scoreboard/components/base-router'
import HistoryInfo from 'scoreboard/components/history-info'

let ctrlPressed = false
var ExportsRouter = BaseRouter.extend({

	routes: {
		'history/:section/:id(/)': 'history',
		'history/:section/:id/periodOnly(/)': 'historyForPeriod'
	},

	initialize: function(options) {
		BaseRouter.prototype.initialize.apply(this, arguments)
		this.options = options || {}

		// Can be used from the console on all environments
		window.gotoExportView = () => {
			$.get(`api/${Backbone.history.getFragment()}/export-route`).then(url => {
				window.open(scoreboardUrl(url))
			})
		}

		// For developers, pressing Ctrl+E will launch the export route of the
		// current page in a new window
		Backbone.once('load', ({config = {}}) => {
			if (config.development) {
				$(document).on('keyup', evt => {
					if(KeyCodes.CTRL === evt.keyCode) {
						ctrlPressed = false
					}
					// Allow ctrl + e shortcut when in a form which is a
					// mac command for going to the end of a line
					if(evt.key === 'e' && ctrlPressed && !evt.target.form) {
						window.gotoExportView()
					}
				})
				$(document).on('keydown', evt => {
					if(KeyCodes.CTRL === evt.keyCode) {
						ctrlPressed = true
						// You get two seconds to press 'e' then you're out of luck
						setTimeout(() => ctrlPressed = false, 2000)
					}
				})
			}
		})

	},

	history: function (section, id) {
		HistoryInfo.exportDisplay(section, id, true)
	},
	historyForPeriod: function (section, id) {
		HistoryInfo.exportDisplay(section, id, false)
	}
})

export default ExportsRouter

ExportsRouter.__filename__ = 'components/export/exports-router.js'
